import {
  DownloadExcelSettlementTypes,
  FetchSettlementHistoryBody,
  FetchTransactionSettlementBody,
  TransactionSettlementResponse,
  UndoSettlementHistoryTypes,
} from '@/pages/Settlements/store/types';
import { AxiosInstance } from 'axios';

export default class SettlementAPI {
  client: AxiosInstance;
  constructor(client: AxiosInstance) {
    this.client = client;
  }

  async fetchTransactionSettlement(data: FetchTransactionSettlementBody) {
    return this.client.post('v2/settlements/settlement-center-trade/', data);
  }

  async fetchSettlementHistory(data: FetchSettlementHistoryBody) {
    return this.client.post('v2/settlements/settlement-center-history/', data);
  }

  async fetchAllSettlements() {
    return this.client.get('v2/settlements/settlement-center-all-settlements/');
  }

  async donwloadExcelSettlements(data: DownloadExcelSettlementTypes) {
    return this.client.post(
      'v2/settlements/settlement-center-download-report/',
      data,
    );
  }

  async donwloadPDFSettlements(data: DownloadExcelSettlementTypes) {
    return this.client.post(
      'v2/settlements/settlement-center-download-report-pdf/',
      data,
    );
  }

  async removeSettlements() {
    return this.client.post(
      'v2/settlements/settlement-center-delete-settlements/',
    );
  }

  async undoSettlementsHistory(data: UndoSettlementHistoryTypes) {
    return this.client.post(
      'v2/settlements/settlement-center-delete-reports/',
      data,
    );
  }

  async setAggregatedSettlements(data: TransactionSettlementResponse[]) {
    const formattedBody = {
      data,
    };
    return this.client.post(
      'v2/settlements/settlement-center-aggregated-trade/',
      formattedBody,
    );
  }
}
